import { TUtilObjectCaseType } from './types';

import { toCamelCase, toSnakeCase } from '@utils/string';

const isArray = Array.isArray;

const isObject = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object' && !isArray(value);
};

const snakeCaseToCamelCaseObject = <T extends Record<string, unknown>>(obj: T): T =>
  Object.entries(obj).reduce(
    (acc, [attr, value]) => ({
      ...acc,
      [toCamelCase(attr)]: isObject(value)
        ? snakeCaseToCamelCaseObject(value)
        : isArray(value)
          ? value.map((v) => (isObject(v) ? snakeCaseToCamelCaseObject(v) : v))
          : value,
    }),
    {} as T,
  );

const snakeCaseToCamelCaseArray = <T extends Record<string, unknown>>(obj: unknown): T[] => {
  if (isArray(obj)) {
    return obj.map((item) => (isObject(item) ? snakeCaseToCamelCaseObject(item) : item)) as T[];
  }
  throw new Error('Input is not an array');
};

const camelCaseToSnakeCaseObject = <T extends Record<string, unknown>>(obj: T): T =>
  Object.entries(obj).reduce(
    (acc, [attr, value]) => ({
      ...acc,
      [toSnakeCase(attr)]: isObject(value)
        ? camelCaseToSnakeCaseObject(value)
        : isArray(value)
          ? value.map((v) => (isObject(v) ? camelCaseToSnakeCaseObject(v) : v))
          : value,
    }),
    {} as T,
  );

const camelCaseToSnakeCaseArray = <T extends Record<string, unknown>>(obj: unknown): T[] => {
  if (isArray(obj)) {
    return obj.map((item) => (isObject(item) ? camelCaseToSnakeCaseObject(item) : item)) as T[];
  }
  throw new Error('Input is not an array');
};

export const convertData = <T extends Record<string, unknown> | Record<string, unknown>[]>(
  value: unknown,
  convertTo: TUtilObjectCaseType,
): T => {
  if (isArray(value)) {
    return (
      convertTo === 'snake_case-to-camelCase'
        ? snakeCaseToCamelCaseArray(value)
        : camelCaseToSnakeCaseArray(value)
    ) as T;
  }

  if (isObject(value)) {
    return (
      convertTo === 'snake_case-to-camelCase'
        ? snakeCaseToCamelCaseObject(value)
        : camelCaseToSnakeCaseObject(value)
    ) as T;
  }

  return value as T;
};
